import { useState } from 'react';

import { FilterSelectDropdown } from '../../Inputs/FilterSelectDropdown';
import { SideMenuFilterTemplete } from '../SideMenuFilterTemplete';

interface IFilterQualityProps {
  isOpen: boolean;
  onToggle: () => void;
  selectedMonth: string;
  selectedYear: string;
  onMonthChange: (month: string) => void;
  onYearChange: (year: string) => void;
  onApplyFilters: () => void;
  loading?: boolean;
}

const MONTHS = [
  { value: '01', label: 'Janeiro' },
  { value: '02', label: 'Fevereiro' },
  { value: '03', label: 'Março' },
  { value: '04', label: 'Abril' },
  { value: '05', label: 'Maio' },
  { value: '06', label: 'Junho' },
  { value: '07', label: 'Julho' },
  { value: '08', label: 'Agosto' },
  { value: '09', label: 'Setembro' },
  { value: '10', label: 'Outubro' },
  { value: '11', label: 'Novembro' },
  { value: '12', label: 'Dezembro' },
];

const generateYears = (): Array<{ value: string; label: string }> => {
  const currentYear = new Date().getFullYear();
  const years: Array<{ value: string; label: string }> = [];

  for (let i = 0; i <= 5; i += 1) {
    const year = (currentYear - i).toString();
    years.push({ value: year, label: year });
  }

  return years;
};

export const FilterQuality = ({
  isOpen,
  onToggle,
  selectedMonth,
  selectedYear,
  onMonthChange,
  onYearChange,
  onApplyFilters,
  loading = false,
}: IFilterQualityProps) => {
  const [localMonth, setLocalMonth] = useState(selectedMonth);
  const [localYear, setLocalYear] = useState(selectedYear);

  const handleCleanFilters = () => {
    const currentDate = new Date();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear().toString();

    setLocalMonth(month);
    setLocalYear(year);
    onMonthChange(month);
    onYearChange(year);
  };

  const handleApplyFilters = () => {
    onMonthChange(localMonth);
    onYearChange(localYear);
    onApplyFilters();
    onToggle();
  };

  return (
    <SideMenuFilterTemplete
      isOpen={isOpen}
      onchange={onToggle}
      title="Filtrar Qualidade"
      cleanAllInputsAction={handleCleanFilters}
      filterAction={handleApplyFilters}
    >
      <FilterSelectDropdown
        title="Mês"
        value={localMonth}
        onChange={setLocalMonth}
        options={MONTHS}
        disabled={loading}
      />
      <FilterSelectDropdown
        title="Ano"
        value={localYear}
        onChange={setLocalYear}
        options={generateYears()}
        disabled={loading}
      />
    </SideMenuFilterTemplete>
  );
};
